<template>
  <div class="justify-content-center mb-3">
    <div class="row">

      <div class="col-lg-2 order-md-1">
        
        <b-form-group label="Select a chart type">
          <b-form-radio-group
          v-model="chartType"
          stacked 
          style="text-align:left">
            <b-form-radio
            v-for="type in chartTypes"
            :key="type"
            :value="type.toLowerCase()">
              {{type}} Type
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div class="col-md-9 order-md-2">
        <highcharts class="chart" ref="chartRef" :options="lineOptions" :updateArgs="[true,true]"></highcharts>
      </div>

      
    </div>
    
  </div>
</template>

<script>

import Highcharts from "highcharts";
import chartTheme from "highcharts/themes/sand-signika";
chartTheme(Highcharts);

export default {
  name: "chart",
  computed: {},
  data () {
    return {
      chartType: 'spline',
      chartTypes: ["Spline","Line","Scatter","Bar","Area","Column","Areaspline"],
      lineOptions: {
        
        chart: {
          type: 'spline',
          spacingBottom: 10,
          spacingTop: 10,
          spacingLeft: 10,
          spacingRight: 10,
        },
        title: {
          text: 'Treatment Progress'
        },

        credits: {
          enabled: false
        },


        yAxis: {
          title: {
            text: 'Difference in degree'
          }
        },

        xAxis: {
          accessibility: {
            rangeDescription: 'Time'
          }
        },

        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },

        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
            pointStart: 1
          }
        },
        tooltip: {
          useHTML: true,
          valueDecimals: 2,
          crosshairs: [true, true],

          formatter: function() {
            return  '<table>' +
                      '<tr><td style="text-align: center;">' + 'You have <strong>' + this.y + '</strong> degree diffence' + '</td></tr>' +
                      '<tr><td style="text-align: center;">' + 'on your <strong>' + this.series.name + '</strong>'        + '</td></tr>' +
                      '<tr><td style="text-align: center;">' + 'in the <strong>Set ' + this.x + '</strong>'               + '</td></tr>' +
                    '</table>';
          },
          
          // styling
          backgroundColor: {
            linearGradient: [0, 0, 20, 70],
            stops: [
              [0, '#FFFFFF'],
              [1, '#E0E0E0']
            ]
          },
          borderColor: 'black',
          borderRadius: 10,
          borderWidth: 0          
        },

        "series": [
          { "name": "Right Hip", "data": [5, 25, 95, 25, 45, 35, 95] },
          { "name": "Right Knee", "data": [18, 8, 68, 28, 8, 8, 58] },
          { "name": "Right Body", "data": [80, 50, 10, 20, 60, 70, 30] }
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }]
        }
      },      
    }
  },
  methods: {
  },
  created () {},
  mounted () {},
  watch: {
    chartType (newVal) {
      /* this.lineOptions.chart.type = newVal;
      this.$refs.chartRef.chart.redraw(); */
      this.$refs.chartRef.chart.update({
        chart: {
          type: newVal,
        },
      });
    },
  }
}
</script>

<style scoped>
</style>
